import HTTPClient from '@elab/core/utils/HTTPClient';
import apiUtils from '@elab/core/utils/apiUtils';

const getApiService = () => `${apiUtils.getBaseUri()}/users/current/loyalty/history`;

const getUrl = ({ pageSize, pageNumber, dateFrom = '', dateTo = '' }) => {
    const params = new URLSearchParams();
    params.append('pageSize', pageSize);
    params.append('pageNumber', pageNumber);
    if (dateFrom && dateTo) {
        params.append('dateFrom', dateFrom);
        params.append('dateTo', dateTo);
    }
    return `${getApiService()}?${params.toString()}`;
};

export const getLoyaltyCardHistory = async queryParams => {
    const url = getUrl(queryParams);
    const response = await HTTPClient().get(url);
    if (!response.ok) {
        throw new Error(`Unable to load loyalty card history (${response.status})`);
    }
    return await response.json();
};
